/* eslint-disable */

import React from "react";
import {
  Box,
  Button,
  Card,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  IconButton,
  List,
  ListItem,
  Stack,
  Tooltip,
  Typography,
} from "@mui/material";
import {
  AltRoute,
  ArrowDownward,
  ArrowUpward,
  Close,
  TwoWheeler,
} from "@mui/icons-material";
import { MobXProviderContext, Observer } from "mobx-react";
import SelecionarEntregadorDialog from "./selecionarEntregadorFlex";

const VERDE = "#2E9E5B";
const AZUL = "#1b468d";

// Lista das "rotas aguardando motoca": pedidos pendentes com Rota != 0,
// agrupados por número de rota. Porte da aba Rotas do app Flutter
// (_buildListaRotas / _cardRota em mapa_page.dart).
function ListaRotas({ maxHeight }) {
  const { mapaStore } = React.useContext(MobXProviderContext);
  const [rotaParaDesfazer, setRotaParaDesfazer] = React.useState(null);

  const RotaCard = ({ rota }) => (
    <Card style={{ width: "100%", marginBottom: 12, padding: 10 }}>
      {/* Cabeçalho: número + qtd */}
      <Stack direction="row" alignItems="center" spacing={1}>
        <AltRoute style={{ fontSize: 18, color: AZUL }} />
        <Typography style={{ fontSize: 15, fontWeight: "bold" }}>
          Rota #{rota.numero}
        </Typography>
        <Box
          style={{
            backgroundColor: "#8bad0d",
            color: "#fff",
            borderRadius: 12,
            padding: "1px 8px",
            fontSize: 11,
            fontWeight: "bold",
          }}
        >
          {rota.quantidade} pedido(s)
        </Box>
      </Stack>

      {/* Motoca da rota */}
      <Stack direction="row" alignItems="center" spacing={0.5} marginTop={0.5}>
        <TwoWheeler
          style={{ fontSize: 15, color: rota.temEntregador ? VERDE : "#9e9e9e" }}
        />
        <Typography
          style={{
            fontSize: 12.5,
            fontWeight: 600,
            color: rota.temEntregador ? VERDE : "#757575",
          }}
        >
          {rota.temEntregador ? rota.entregadorNome : "Sem motoqueiro"}
        </Typography>
      </Stack>

      <Divider style={{ marginTop: 8, marginBottom: 6 }} />

      {/* Pedidos da rota, em ordem, com ↑↓ e ✕ */}
      {rota.pedidos.map((pedido, index) => (
        <Stack
          key={pedido.id}
          direction="row"
          alignItems="center"
          spacing={1}
          paddingY={0.4}
        >
          <Box
            style={{
              minWidth: 22,
              height: 22,
              borderRadius: 11,
              backgroundColor: AZUL,
              color: "#fff",
              fontSize: 12,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
            }}
          >
            {index + 1}
          </Box>

          <Box style={{ flex: 1, minWidth: 0 }}>
            <Typography variant="body2" style={{ fontWeight: 600 }} noWrap>
              #{pedido.sequenciaPdv} — {pedido.cliente}
            </Typography>
            <Typography variant="caption" color="text.secondary" noWrap
              style={{ display: "block" }}>
              {pedido.endereco}
            </Typography>
          </Box>

          <Stack direction="row" flexShrink={0}>
            <IconButton
              size="small"
              disabled={index === 0 || mapaStore.inProgress}
              onClick={() => mapaStore.moverPedidoNaRota(rota, index, -1)}
            >
              <ArrowUpward style={{ fontSize: 16 }} />
            </IconButton>
            <IconButton
              size="small"
              disabled={index === rota.pedidos.length - 1 || mapaStore.inProgress}
              onClick={() => mapaStore.moverPedidoNaRota(rota, index, 1)}
            >
              <ArrowDownward style={{ fontSize: 16 }} />
            </IconButton>
            <Tooltip title="Tirar da rota">
              <span>
                <IconButton
                  size="small"
                  disabled={mapaStore.inProgress}
                  onClick={() => mapaStore.removerPedidoDaRota(pedido)}
                >
                  <Close style={{ fontSize: 16 }} />
                </IconButton>
              </span>
            </Tooltip>
          </Stack>
        </Stack>
      ))}

      <Divider style={{ marginTop: 6, marginBottom: 4 }} />

      {/* Ações da rota: Exibir | Definir entregador | Desfazer */}
      <Stack direction="row" spacing={1} justifyContent="space-evenly">
        <Button
          size="small"
          disabled={mapaStore.inProgress}
          onClick={() => mapaStore.calcularRotaPedidos(rota.pedidos)}
        >
          Exibir
        </Button>
        <SelecionarEntregadorDialog rota={rota} label="Definir entregador" />
        <Button
          size="small"
          color="error"
          disabled={mapaStore.inProgress}
          onClick={() => setRotaParaDesfazer(rota)}
        >
          Desfazer
        </Button>
      </Stack>
    </Card>
  );

  return (
    <>
      <Observer>
        {() => (
          <List
            sx={{
              backgroundColor: "#eaeaea",
              width: "100%",
              maxHeight: maxHeight,
              overflow: "auto",
              paddingTop: 1,
            }}
          >
            {mapaStore.rotas.length > 0 ? (
              mapaStore.rotas.map((rota) => (
                <ListItem key={rota.numero} disableGutters>
                  <RotaCard rota={rota} />
                </ListItem>
              ))
            ) : (
              <Stack alignItems="center" style={{ padding: 24 }}>
                <Typography variant="body2" color="text.secondary" align="center">
                  Nenhuma rota montada.
                </Typography>
                <Typography
                  variant="caption"
                  color="text.secondary"
                  align="center"
                >
                  Selecione pedidos na aba Pendentes e clique em "Criar rota".
                </Typography>
              </Stack>
            )}
          </List>
        )}
      </Observer>

      {/* Confirmação de desfazer rota */}
      <Dialog
        open={rotaParaDesfazer !== null}
        onClose={() => setRotaParaDesfazer(null)}
      >
        <DialogTitle>
          Desfazer Rota #{rotaParaDesfazer ? rotaParaDesfazer.numero : ""}?
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            Os pedidos voltam para "Pendentes" (sem rota e sem motoca).
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setRotaParaDesfazer(null)}>CANCELAR</Button>
          <Button
            variant="contained"
            color="error"
            onClick={() => {
              mapaStore.desfazerRota(rotaParaDesfazer);
              setRotaParaDesfazer(null);
            }}
          >
            DESFAZER
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default ListaRotas;
